import React from "react";
import { BadgeIndianRupee } from "lucide-react";

const LoanDetails = ({ application }) => {
  // Find approved distribution using same logic as BankCard
  const approvedDistribution = application?.BanksApprovalDetails?.find(
    dist => dist.status === "approved"
  );

  // Get banking partner details from approved distribution
  const bankingPartner = approvedDistribution?.bankingPartner;
  
  // Find matching loan detail from banking partner's loanDetails
  const matchingLoanDetail = bankingPartner?.loanDetails?.find(
    ld => String(ld.loanType).trim().toLowerCase() === 
          String(application?.loanType).trim().toLowerCase()
  );

  // Calculate EMI if we have banking partner loan details
  const calculateEMI = (principal, interestRate, months) => {
    if (!principal || !interestRate || !months) return null;
    const r = interestRate / 12 / 100;
    const n = months;
    return r === 0 ? principal / n : 
           (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
  };

  // Get values from approved distribution or calculate from banking partner details
  const getInterestRate = () => {
    if (approvedDistribution?.interestRateForCustomer) {
      return approvedDistribution.interestRateForCustomer + "% p.a";
    }
    if (matchingLoanDetail?.interestRate) {
      return matchingLoanDetail.interestRate + "% p.a";
    }
    return application?.interest ? application.interest + "% p.a" : "-";
  };

  const getEMI = () => {
    if (approvedDistribution?.emi) {
      return approvedDistribution.emi;
    }
    if (matchingLoanDetail?.interestRate && application?.principle && application?.monthsToRepay) {
      const calculatedEMI = calculateEMI(
        application.principle,
        parseFloat(matchingLoanDetail.interestRate),
        application.monthsToRepay
      );
      return calculatedEMI ? Number(calculatedEMI.toFixed(2)) : null;
    }
    return application?.emi || application?.monthlyEMI || null;
  };

  console.log("LoanDetails - approvedDistribution:", approvedDistribution);
  console.log("LoanDetails - bankingPartner:", bankingPartner);
  console.log("LoanDetails - matchingLoanDetail:", matchingLoanDetail);

  // Use exact same formatCurrency function as BankCard
  const formatCurrency = (amount) => {
    if (typeof amount === "number") {
      return `₹${new Intl.NumberFormat("en-IN").format(amount)}`;
    }
    return "-";
  };

  return (
    <div className="bg-[#131313] rounded-lg p-4 mb-4">
      <div className="flex items-center mb-4">
        <span className="text-white text-lg mr-2"><BadgeIndianRupee className="text-[#ffca20]" /></span>
        <h3 className="text-white text-lg">Loan Details</h3>
      </div>

      {/* Main amount card */}
      <div className="flex gap-4 w-full mb-4">
        <div className="flex-1 flex-col rounded-md p-4 border border-[#333333]">
          <p className="text-[#F3F3F3] text-xs mb-1">Approved Amount</p>
          <p className="text-[#FFCA20] font-semibold text-lg my-0">
            {formatCurrency(
              approvedDistribution?.approveAmount ||
                application?.approvedAmount ||
                application?.principle
            )}
          </p>
        </div>
      </div>

      {/* Details grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
        <div>
          <p className="text-gray-400 text-sm mb-1">Loan Type</p>
          <p className="text-white text-base font-medium">
            {application?.loanType || "-"}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm mb-1">Tenure Requested</p>
          <p className="text-white text-base font-medium">
            {approvedDistribution?.tenureMonths ||
              (application?.monthsToRepay
                ? `${application.monthsToRepay} months`
                : "-")}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm mb-1">Processing Fee</p>
          <p className="text-white text-base font-medium">
            {formatCurrency(
              approvedDistribution?.processingFee || application?.processingFee
            )}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm mb-1">Insurance Fees</p>
          <p className="text-white text-base font-medium">
            {formatCurrency(
              approvedDistribution?.insuranceFees || application?.insuranceFee
            )}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-sm mb-1">Platform Fees</p>
          <p className="text-white text-base font-medium">
            {formatCurrency(
              approvedDistribution?.platformFee || application?.platformFee
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoanDetails;
